import { Stack, Typography } from '@mui/material';
import { ResultRow } from './ResultRow';
export function SpeechTest({ testDetails }) {
  const formattedAphasiaValue = () => {
    if (!testDetails?.aphasiaResponse) {
      return 'Cannot determine';
    }
    return testDetails?.aphasiaDetected ? 'YES' : 'NO';
  };

  const formattedDysarthriaValue = () => {
    if (!testDetails?.dysarthriaResponse) {
      return 'Cannot determine';
    }
    return testDetails?.dysarthriaDetected ? 'YES' : 'NO';
  };

  return (
    <>
      <Stack sx={{ height: '460px' }} justifyContent="space-between">
        <ResultRow title="Dysarthria" value={formattedDysarthriaValue()} />
        <Stack>
          <ResultRow title="Aphasia" value={formattedAphasiaValue()} />
          {testDetails?.aphasiaResponse && (
            <Typography variant="body" color="textPrimary">
              Patient Answer: {testDetails?.aphasiaResponse}
            </Typography>
          )}
        </Stack>
        <ResultRow title="Mute" value="NO" />
      </Stack>
    </>
  );
}
